import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import Home from "@/pages/Home";
import Programmes from "@/pages/Programmes";
import CourseDetail from "@/pages/CourseDetail";
import Donate from "@/pages/Donate";
import Contact from "@/pages/Contact";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import RunSheet from "@/pages/RunSheet";
import Driver from "@/pages/Driver";
import SafePlace from "@/pages/SafePlace";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import { QuickExit } from "@/components/site/QuickExit";

const Protected = ({ children, admin, roles }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <main className="min-h-screen bg-sand" />;
  if (!user) return <Navigate to={`/login?next=${loc.pathname}`} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SmoothScroll />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/programmes" element={<Programmes />} />
          <Route path="/programmes/:slug" element={<CourseDetail />} />
          <Route path="/donate" element={<Donate />} />
          <Route path="/safe-place" element={<SafePlace />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<AuthPage mode="login" />} />
          <Route path="/register" element={<AuthPage mode="register" />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
          <Route path="/admin/run-sheet" element={<Protected admin><RunSheet /></Protected>} />
          <Route path="/driver" element={<Protected roles={["admin", "driver"]}><Driver /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Footer />
        <QuickExit />
        <Toaster position="bottom-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
